import Collapse from 'react-collapse';
import domainVariants from '../../../global-variables-provider/domain-variants';
import SegmentCriticalInfo from './SegmentCriticalInfo';
const BbcSegmentAnnouncement = () => /*#__PURE__*/React.createElement(React.Fragment, null, domainVariants.isWl && /*#__PURE__*/React.createElement("div", {
  className: "bbc-segment-announcement checkout-details"
}, /*#__PURE__*/React.createElement("div", {
  className: "checkout-details__content"
}, /*#__PURE__*/React.createElement("div", {
  className: "responsive-container"
}, /*#__PURE__*/React.createElement(SegmentCriticalInfo, {
  skipMargins: true
}, /*#__PURE__*/React.createElement("p", null, I18n.t('components.BbcSegmentAnnouncement.note_one')), /*#__PURE__*/React.createElement("p", null, I18n.t('components.BbcSegmentAnnouncement.note_two')))))));
export default BbcSegmentAnnouncement;